module.exports = __webpack_public_path__ + "static/media/game_roadmap_map.6855dafd.png";